// extracted by mini-css-extract-plugin
export default {"newMessageRecipientContainer":"NewMessageRecipient_newMessageRecipientContainer__1NDOL","messageParticipantPictureWrap":"NewMessageRecipient_messageParticipantPictureWrap__3txuN"};